import { setFormValues } from "../CreateCertificateModalSlice";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { Dispatch } from "redux";
import { getQualificationFormValidityValues } from "../../../common/utils/getQualificationFormValidityValues";

interface Props {
    selectedQualification: QualificationInterface | null;
    formValues?: {
        qualification: {
            selectedId: string;
            selectedValue: string;
            validityPeriod: string;
        };
    };
    dispatch: Dispatch;
}

export const setQualificationValues = (props: Props): void => {
    const { formValues, selectedQualification, dispatch } = props;

    if (selectedQualification && !formValues?.qualification) {
        dispatch(
            setFormValues({
                ...formValues,
                qualification: getQualificationFormValidityValues(
                    selectedQualification,
                ),
            }),
        );
    }
};
